import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule]
})
export class SpinnerComponent implements OnInit {
  @Input() loadingText!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
